export default "__VITE_ASSET__hafPUXeI__"